import React, { useState, useEffect, useRef, useCallback } from 'react';
import Amenities from './Amenities';
import Integrations from './Integrations';
import PropertyPage from './PropertyPage';
import './dashboard-v2.css';

const API = process.env.REACT_APP_API_URL || '/api';
const tok = () => localStorage.getItem('hospeo_token');
const api = (path, opts = {}) => {
  const headers = { 'Authorization': `Bearer ${tok()}` };
  if (!(opts.body instanceof FormData)) headers['Content-Type'] = 'application/json';
  return fetch(`${API}${path}`, { ...opts, headers: { ...headers, ...opts.headers } });
};
const fmt = d => d ? new Date(d).toLocaleDateString('fr-FR') : '—';
const fmtDT = d => d ? new Date(d).toLocaleString('fr-FR', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' }) : '—';
const daysUntil = d => d ? Math.ceil((new Date(d) - new Date()) / 86400000) : null;

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Cormorant+Garamond:wght@500;600&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/tabler-icons/2.44.0/iconfont/tabler-icons.min.css');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{--black:#1A1A1A;--g1:#4A4A48;--g2:#6B6B6B;--g3:#B4B2A9;--border:#EBEBEB;--bg:#F7F7F5;--white:#FFFFFF;--red:#1A1A1A;--red2:#000000;--green:#3B6D11;--amber:#854F0B;--blue:#1A1A1A;--r8:10px;--r12:14px;--r16:18px;--sidebar:224px}
body{font-family:'DM Sans',-apple-system,sans-serif;background:var(--bg);color:var(--black);-webkit-font-smoothing:antialiased}
.layout{display:flex;min-height:100vh}
.sidebar{width:var(--sidebar);background:var(--white);border-right:0.5px solid var(--border);display:flex;flex-direction:column;position:fixed;top:0;left:0;bottom:0;z-index:50;overflow-y:auto;transition:transform .2s ease}
.main{margin-left:var(--sidebar);flex:1;min-height:100vh;display:flex;flex-direction:column;min-width:0}
.sb-logo{padding:20px 18px 14px;border-bottom:0.5px solid var(--border);display:flex;align-items:center;justify-content:space-between}
.sb-logo img{height:26px;object-fit:contain}
.sb-logo-t{font-family:'Cormorant Garamond',serif;font-size:19px;font-weight:600;letter-spacing:.2px}
.sb-logo-s{font-size:10px;color:var(--g2);letter-spacing:.3px;text-transform:uppercase;margin-top:1px}
.sb-close{display:none;border:none;background:none;cursor:pointer;color:var(--g2);font-size:20px;padding:4px}
.sb-nav{flex:1;padding:10px 8px}
.sb-sec{font-size:10px;font-weight:600;color:var(--g3);text-transform:uppercase;letter-spacing:.8px;padding:10px 10px 5px}
.ni{display:flex;align-items:center;gap:10px;padding:9px 11px;border-radius:50px;cursor:pointer;font-size:13px;font-weight:500;color:#4A4A48 !important;transition:.15s;margin-bottom:1px;border:none;background:#fff;width:100%;text-align:left;font-family:inherit}
.ni:hover{background:var(--bg);color:var(--black)}
.ni.on{background:#1A1A1A !important;color:#fff !important;font-weight:600}
.ni-ico{font-size:16px;width:18px;text-align:center;flex-shrink:0;display:inline-flex;align-items:center;justify-content:center}
.sb-foot{padding:14px 16px;border-top:0.5px solid var(--border)}
.sb-user{font-size:12px;font-weight:600;color:var(--black)}
.sb-email{font-size:11px;color:var(--g3);margin-bottom:7px}
.sb-out{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:500;color:var(--g2);background:none;border:none;cursor:pointer;font-family:inherit}
.sb-out:hover{color:var(--black)}
.sb-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:49}
.topbar{background:var(--white);border-bottom:0.5px solid var(--border);padding:14px 22px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0;gap:12px}
.topbar-left{display:flex;align-items:center;gap:12px;min-width:0}
.sb-burger{display:none;border:none;background:#fff;cursor:pointer;color:#1A1A1A !important;font-size:20px;padding:4px;flex-shrink:0}
.page-title{font-family:'Cormorant Garamond',serif;font-size:20px;font-weight:600;letter-spacing:.1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.topbar-date{font-size:12px;color:var(--g2);white-space:nowrap;flex-shrink:0}
.content{padding:20px;flex:1;min-width:0}
.stats-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin-bottom:18px}
.stat-card{background:var(--white);border:0.5px solid var(--border);border-radius:16px;padding:16px;box-shadow:0 2px 16px rgba(0,0,0,0.04)}
.stat-label{font-size:10px;font-weight:600;color:var(--g2);text-transform:uppercase;letter-spacing:.6px;margin-bottom:7px}
.stat-value{font-size:26px;font-weight:600;letter-spacing:-.3px;color:var(--black)}
.stat-sub{font-size:11px;color:var(--g2);margin-top:2px}
.stat-red .stat-value{color:var(--black)}.stat-green .stat-value{color:var(--green)}.stat-amber .stat-value{color:var(--amber)}
.grid-2{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.grid-3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:14px}
.card{background:var(--white);border:0.5px solid var(--border);border-radius:18px;overflow:hidden;margin-bottom:14px;box-shadow:0 2px 16px rgba(0,0,0,0.04)}
.card-hdr{padding:14px 18px;border-bottom:0.5px solid var(--border);display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap}
.card-title{font-size:14px;font-weight:600;display:flex;align-items:center;gap:8px}
.card-actions{display:flex;gap:8px;align-items:center;flex-wrap:wrap}
.search-wrap{position:relative}
.search-ico{position:absolute;left:10px;top:50%;transform:translateY(-50%);font-size:14px;color:var(--g3);display:flex}
.search-in{padding:8px 10px 8px 30px;border:0.5px solid var(--border);border-radius:50px;font-size:13px;font-family:inherit;outline:none;width:180px;background:var(--white)}
.search-in:focus{border-color:var(--black)}
.fsel{padding:8px 12px;border:0.5px solid var(--border);border-radius:50px;font-size:13px;font-family:inherit;outline:none;background:var(--white);cursor:pointer}
.table-wrap{overflow-x:auto;overflow-y:auto;-webkit-overflow-scrolling:touch;max-height:70vh}
table{width:100%;border-collapse:collapse}
th{padding:10px 16px;font-size:10px;font-weight:600;color:var(--g2);text-transform:uppercase;letter-spacing:.6px;text-align:left;background:var(--bg);border-bottom:0.5px solid var(--border);white-space:nowrap}
td{padding:12px 16px;font-size:13px;border-bottom:0.5px solid var(--border)}
tr:last-child td{border-bottom:none}
tr:hover td{background:#FAFAF8}
.badge{display:inline-flex;align-items:center;gap:4px;padding:3px 9px;border-radius:50px;font-size:11px;font-weight:600;white-space:nowrap}
.badge i{font-size:12px}
.bg{background:#EAF3DE;color:#27500A}.ba{background:#FAEEDA;color:#633806}.br{background:#FCEBEB;color:#791F1F}.bgr{background:var(--bg);color:var(--g2)}.bb{background:#F0F0EE;color:var(--black)}
.btn{padding:8px 14px;border-radius:50px;font-size:13px;font-weight:500;cursor:pointer;font-family:inherit;transition:.15s;border:none;white-space:nowrap;display:inline-flex;align-items:center;gap:6px;justify-content:center}
.btn i{font-size:14px}
.btn-p{background:var(--black);color:var(--white)}.btn-p:hover{background:#000}
.btn-s{background:var(--white);color:var(--black);border:0.5px solid var(--border)}.btn-s:hover{border-color:var(--black)}
.btn-d{background:#FCEBEB;color:#791F1F;border:0.5px solid #F7C1C1}.btn-d:hover{background:#F7C1C1}
.btn-sm{padding:5px 11px;font-size:12px}
.btn-icon{padding:6px;width:30px;height:30px}
.btn:disabled{opacity:.5;cursor:not-allowed}
.pag{padding:11px 18px;display:flex;align-items:center;justify-content:space-between;border-top:0.5px solid var(--border);flex-wrap:wrap;gap:8px}
.pag-info{font-size:12px;color:var(--g2)}
.pag-btns{display:flex;gap:4px}
.pag-btn{padding:5px 10px;border:0.5px solid var(--border);border-radius:50px;font-size:12px;font-weight:500;background:var(--white);color:var(--black);cursor:pointer;font-family:inherit}
.pag-btn.on{background:var(--black);color:var(--white);border-color:var(--black)}
.pag-btn:disabled{opacity:.4;cursor:not-allowed}
.overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:200;display:flex;align-items:center;justify-content:center;padding:16px}
.modal{background:var(--white);border-radius:20px;width:100%;max-width:640px;max-height:92vh;overflow-y:auto;box-shadow:0 20px 60px rgba(0,0,0,.16)}
.modal-hdr{padding:16px 20px;border-bottom:0.5px solid var(--border);display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;background:var(--white);z-index:1}
.modal-title{font-family:'Cormorant Garamond',serif;font-size:17px;font-weight:600}
.modal-close{width:28px;height:28px;border:none;background:var(--bg);border-radius:50%;cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;color:var(--g1)}
.modal-body{padding:20px}
.modal-footer{padding:14px 20px;border-top:0.5px solid var(--border);display:flex;gap:8px;justify-content:flex-end}
.ff{margin-bottom:14px}
.fl{font-size:11px;font-weight:600;color:var(--g2);text-transform:uppercase;letter-spacing:.6px;margin-bottom:6px;display:block}
.fi{width:100%;padding:10px 12px;border:0.5px solid var(--border);border-radius:var(--r8);font-size:14px;font-family:inherit;outline:none;color:var(--black);transition:.15s;background:var(--white)}
.fi:focus{border-color:var(--black)}
.fta{width:100%;padding:10px 12px;border:0.5px solid var(--border);border-radius:var(--r8);font-size:12.5px;font-family:inherit;outline:none;color:var(--black);min-height:120px;resize:vertical;line-height:1.65;background:var(--white)}
.fta:focus{border-color:var(--black)}
.fta-contract{min-height:300px;font-family:monospace;font-size:12px}
.fsel2{width:100%;padding:10px 12px;border:0.5px solid var(--border);border-radius:var(--r8);font-size:14px;font-family:inherit;outline:none;background:var(--white);cursor:pointer}
.frow{display:grid;grid-template-columns:1fr 1fr;gap:12px}
.tabs{display:flex;gap:6px;margin-bottom:16px;flex-wrap:wrap}
.tab{padding:8px 16px;border-radius:50px;font-size:13px;font-weight:500;cursor:pointer;border:0.5px solid var(--border);background:var(--white);color:var(--g2);font-family:inherit;transition:.15s}
.tab.on{background:var(--black);color:var(--white);border-color:var(--black)}
.dr{display:flex;justify-content:space-between;padding:10px 0;border-bottom:0.5px solid var(--border);font-size:13px;gap:12px}
.dr:last-child{border-bottom:none}
.dl{color:var(--g2);font-weight:500;flex-shrink:0}.dv{color:var(--black);font-weight:600;text-align:right;max-width:60%;display:flex;align-items:center;gap:6px;justify-content:flex-end}
.empty{padding:40px 20px;text-align:center}
.empty-ico{font-size:26px;margin-bottom:10px;opacity:.4;color:var(--g2)}
.empty-t{font-size:14px;font-weight:600;margin-bottom:4px}.empty-s{font-size:13px;color:var(--g2)}
.login-page{min-height:100vh;display:flex;align-items:center;justify-content:center;background:var(--bg);padding:16px}
.login-card{background:var(--white);border:0.5px solid var(--border);border-radius:20px;padding:32px;width:100%;max-width:340px;box-shadow:0 2px 24px rgba(0,0,0,0.06)}
.login-logo{text-align:center;margin-bottom:24px}
.login-t{font-family:'Cormorant Garamond',serif;font-size:22px;font-weight:600;letter-spacing:.1px}.login-s{font-size:11px;color:var(--g2);margin-top:3px;text-transform:uppercase;letter-spacing:.4px}
.toast{position:fixed;bottom:20px;right:20px;left:20px;padding:11px 18px;border-radius:50px;font-size:13px;font-weight:500;z-index:999;animation:si .2s ease;max-width:320px;margin-left:auto;box-shadow:0 4px 20px rgba(0,0,0,0.1);display:flex;align-items:center;gap:8px}
.tok{background:#EAF3DE;color:#27500A;border:0.5px solid #C0DD97}.ter{background:#FCEBEB;color:#791F1F;border:0.5px solid #F7C1C1}
@keyframes si{from{transform:translateY(8px);opacity:0}to{transform:translateY(0);opacity:1}}
.spin{display:inline-block;width:14px;height:14px;border:2px solid rgba(0,0,0,.12);border-top-color:currentColor;border-radius:50%;animation:rot .7s linear infinite;vertical-align:middle}
@keyframes rot{to{transform:rotate(360deg)}}
@keyframes fi{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:translateY(0)}}
.fia{animation:fi .2s ease}
.vars-hint{background:var(--bg);border:0.5px solid var(--border);border-radius:var(--r8);padding:11px 13px;font-size:11px;color:var(--g1);line-height:1.6;margin-bottom:12px}
.vars-hint strong{display:block;margin-bottom:4px;font-size:12px;color:var(--black)}
.prop-check{display:flex;align-items:center;gap:8px;padding:9px 11px;border:0.5px solid var(--border);border-radius:12px;cursor:pointer;transition:.15s;margin-bottom:6px}
.prop-check:hover{border-color:var(--black);background:var(--bg)}
.prop-check.on{border-color:var(--black);background:var(--bg)}
.prop-check input{accent-color:var(--black);width:15px;height:15px;cursor:pointer}
.doc-btn{display:inline-flex;align-items:center;gap:6px;padding:5px 10px;border:0.5px solid var(--border);border-radius:50px;font-size:11px;font-weight:500;color:var(--black);background:var(--white);cursor:pointer;text-decoration:none;transition:.15s}
.doc-btn:hover{border-color:var(--black);background:var(--bg)}
.doc-btn i{font-size:13px}
.upload-box{border:2px dashed var(--border);border-radius:var(--r12);padding:24px;text-align:center;cursor:pointer;transition:.15s}
.upload-box:hover{border-color:var(--g3)}
.upload-box.ok{border-color:var(--green)}
.upload-ico{font-size:26px;margin-bottom:8px;color:var(--g3)}

@media (max-width: 860px) {
  .sidebar{transform:translateX(-100%);width:264px}
  .sidebar.open{transform:translateX(0)}
  .sb-close{display:flex;align-items:center;justify-content:center}
  .sb-overlay.open{display:block}
  .main{margin-left:0}
  .sb-burger{display:flex;align-items:center;justify-content:center}
  .stats-grid{grid-template-columns:1fr 1fr}
  .grid-2,.grid-3{grid-template-columns:1fr}
  .content{padding:14px}
  .topbar{padding:12px 14px}
  .topbar-date{display:none}
  .card-hdr{flex-direction:column;align-items:stretch}
  .card-actions{width:100%}
  .search-in{width:100%}
  .frow{grid-template-columns:1fr}
}
@media (max-width: 480px) {
  .stats-grid{grid-template-columns:1fr 1fr}
  .stat-value{font-size:22px}
  .modal{max-width:100%;border-radius:20px 20px 0 0;position:fixed;bottom:0;max-height:88vh}
  .overlay{align-items:flex-end;padding:0}
  .toast{left:12px;right:12px;max-width:none}
}
`;

function Toast({ msg, type, onDone }) {
  useEffect(() => { const t = setTimeout(onDone, 3000); return () => clearTimeout(t); }, [onDone]);
  return <div className={`toast ${type === 'ok' ? 'tok' : 'ter'}`}>{msg}</div>;
}

function Modal({ title, onClose, children, footer, wide }) {
  return (
    <div className="overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal fia" style={wide ? { maxWidth: 780 } : {}}>
        <div className="modal-hdr">
          <div className="modal-title">{title}</div>
          <button className="modal-close" onClick={onClose}><i className="ti ti-x"></i></button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true); setErr('');
    try {
      const r = await fetch(`${API}/admin/login`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, password: pw }) });
      const d = await r.json();
      if (d.success) { localStorage.setItem('hospeo_token', d.token); onLogin(d.admin); }
      else setErr(d.error || 'Identifiants incorrects');
    } catch { setErr('Erreur réseau'); } finally { setBusy(false); }
  };
  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo"><div className="login-t">HOSPEO</div><div className="login-s">Administration</div></div>
        <div className="ff"><label className="fl">Email</label><input className="fi" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="email@hospeo.ma" onKeyDown={e => e.key === 'Enter' && submit()} autoFocus /></div>
        <div className="ff"><label className="fl">Mot de passe</label><input className="fi" type="password" value={pw} onChange={e => setPw(e.target.value)} placeholder="••••••••" onKeyDown={e => e.key === 'Enter' && submit()} /></div>
        <button className="btn btn-p" style={{ width: '100%', padding: 11, fontSize: 14, marginTop: 4 }} onClick={submit} disabled={busy}>{busy ? <span className="spin" /> : 'Se connecter'}</button>
        {err && <div style={{ fontSize: 13, color: 'var(--red)', marginTop: 10, textAlign: 'center' }}>{err}</div>}
      </div>
    </div>
  );
}

// ── Dashboard ─────────────────────────────────────────────────────────────────
function Dashboard({ onNav }) {
  const [data, setData] = useState(null);
  useEffect(() => { api('/admin/dashboard').then(r => r.json()).then(d => { if (d.success) setData(d); }).catch(() => {}); }, []);
  if (!data) return <div className="content"><div className="empty"><span className="spin" /></div></div>;
  const { stats, by_property, recent_fiches } = data;
  return (
    <div className="content fia">
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total fiches</div><div className="stat-value">{stats.total_fiches}</div><div className="stat-sub">Toutes propriétés</div></div>
        <div className="stat-card stat-green"><div className="stat-label">Ce mois</div><div className="stat-value">{stats.fiches_this_month}</div><div className="stat-sub">Soumises</div></div>
        <div className="stat-card stat-amber"><div className="stat-label">Arrivées aujourd'hui</div><div className="stat-value">{stats.checkin_today}</div><div className="stat-sub">Check-in</div></div>
        <div className="stat-card stat-red"><div className="stat-label">CIN manquants</div><div className="stat-value">{stats.missing_cin}</div><div className="stat-sub">À relancer</div></div>
      </div>
      <div className="grid-2">
        <div className="card">
          <div className="card-hdr"><div className="card-title">Par propriété</div></div>
          {by_property.map(p => (
            <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 16px', borderBottom: '1px solid var(--border)' }}>
              <div><div style={{ fontSize: 13, fontWeight: 600 }}>{p.name}</div><div style={{ fontSize: 11, color: 'var(--g2)' }}>{p.city}</div></div>
              <div style={{ textAlign: 'right' }}><div style={{ fontSize: 18, fontWeight: 700, color: 'var(--red)' }}>{p.fiches_count}</div><div style={{ fontSize: 10, color: 'var(--g2)' }}>{p.upcoming} à venir</div></div>
            </div>
          ))}
        </div>
        <div className="card">
          <div className="card-hdr"><div className="card-title">Dernières fiches</div><button className="btn btn-s btn-sm" onClick={() => onNav('fiches')}>Voir tout</button></div>
          <table><thead><tr><th>Guest</th><th>Propriété</th><th>Arrivée</th></tr></thead>
            <tbody>{recent_fiches.map(f => (
              <tr key={f.id}><td style={{ fontWeight: 600 }}>{f.prenom} {f.nom}</td><td style={{ fontSize: 12, color: 'var(--g2)' }}>{f.property_name}</td>
                <td><span className={`badge ${daysUntil(f.checkin_date) <= 1 ? 'br' : daysUntil(f.checkin_date) <= 3 ? 'ba' : 'bgr'}`}>{fmt(f.checkin_date)}</span></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ── Fiche Detail Modal ────────────────────────────────────────────────────────
function FicheModal({ fiche, onClose, toast }) {
  const days = daysUntil(fiche.checkin_date);
  const openDoc = (type) => window.open(`${API}/admin/fiches/${fiche.id}/${type}?token=${tok()}`, '_blank');
  return (
    <Modal title={`${fiche.prenom} ${fiche.nom}`} onClose={onClose} footer={<button className="btn btn-p" onClick={onClose}>Fermer</button>}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {fiche.fiche_pdf_filename && <button className="doc-btn doc-btn-pdf" onClick={() => openDoc('fiche-pdf')}><i className="ti ti-file-text"></i>Fiche de police</button>}
        {fiche.contract_pdf_filename && <button className="doc-btn doc-btn-pdf" onClick={() => openDoc('contract-pdf')}><i className="ti ti-clipboard-text"></i>Contrat signé</button>}
        {fiche.cin_filename && <button className="doc-btn doc-btn-cin" onClick={() => openDoc('cin')}><i className="ti ti-id"></i>CIN / Passeport</button>}
      </div>
      <div className="dr"><span className="dl">Propriété</span><span className="dv" style={{ color: 'var(--red)' }}>{fiche.property_name}</span></div>
      <div className="dr"><span className="dl">Sexe</span><span className="dv">{fiche.sexe || '—'}</span></div>
      <div className="dr"><span className="dl">Nationalité</span><span className="dv">{fiche.nationalite}</span></div>
      <div className="dr"><span className="dl">Date de naissance</span><span className="dv">{fmt(fiche.date_naissance)}</span></div>
      <div className="dr"><span className="dl">Pays de résidence</span><span className="dv">{fiche.pays_residence}</span></div>
      <div className="dr"><span className="dl">Pièce d'identité</span><span className="dv">{fiche.nature_piece}</span></div>
      <div className="dr"><span className="dl">Numéro</span><span className="dv" style={{ fontFamily: 'monospace' }}>{fiche.numero_piece}</span></div>
      <div className="dr"><span className="dl">Enfants</span><span className="dv">{fiche.nb_enfants || 0}</span></div>
      <div className="dr"><span className="dl">Arrivée</span><span className="dv">{fmt(fiche.checkin_date)} {days !== null && <span className={`badge ${days <= 1 ? 'br' : days <= 3 ? 'ba' : 'bgr'}`}>J-{Math.abs(days)}</span>}</span></div>
      <div className="dr"><span className="dl">Départ</span><span className="dv">{fmt(fiche.checkout_date)}</span></div>
      <div className="dr"><span className="dl">Email guest</span><span className="dv">{fiche.guest_email || '—'}</span></div>
      <div className="dr"><span className="dl">CIN uploadé</span><span className="dv">{fiche.cin_filename ? <span className="badge bg"><i className="ti ti-check"></i>Oui</span> : <span className="badge br"><i className="ti ti-x"></i>Non</span>}</span></div>
      <div className="dr"><span className="dl">Contrat signé</span><span className="dv">{fiche.contract_id ? <span className="badge bg"><i className="ti ti-check"></i>Oui</span> : <span className="badge bgr">—</span>}</span></div>
      <div className="dr"><span className="dl">Soumis le</span><span className="dv">{fmtDT(fiche.submitted_at)}</span></div>
      <div className="dr"><span className="dl">Réf.</span><span className="dv" style={{ fontSize: 10, fontFamily: 'monospace', color: 'var(--g3)' }}>{fiche.id}</span></div>
    </Modal>
  );
}

// ── Fiches ────────────────────────────────────────────────────────────────────
function Fiches({ properties, toast }) {
  const [fiches, setFiches] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [search, setSearch] = useState('');
  const [propFilter, setPropFilter] = useState('');
  const [cinFilter, setCinFilter] = useState('');
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (p = 1) => {
    setLoading(true);
    const params = new URLSearchParams({ page: p, limit: 15 });
    if (search) params.set('search', search);
    if (propFilter) params.set('property', propFilter);
    if (cinFilter) params.set('missing_cin', '1');
    try {
      const r = await api(`/admin/fiches?${params}`);
      const d = await r.json();
      if (d.success) { setFiches(d.fiches); setTotal(d.total); setPages(d.pages); setPage(d.page); }
    } catch { } finally { setLoading(false); }
  }, [search, propFilter, cinFilter]);

  useEffect(() => { load(1); }, [search, propFilter, cinFilter]);

  const del = async (id) => {
    if (!window.confirm('Supprimer cette fiche et tous ses documents ?')) return;
    const r = await api(`/admin/fiches/${id}`, { method: 'DELETE' });
    const d = await r.json();
    toast(d.success ? 'Fiche supprimée' : d.error, d.success ? 'ok' : 'err');
    load(page);
  };

  return (
    <div className="content fia">
      <div className="card">
        <div className="card-hdr">
          <div className="card-title">Fiches <span style={{ color: 'var(--g2)', fontWeight: 400 }}>({total})</span></div>
          <div className="card-actions">
            <div className="search-wrap"><span className="search-ico"><i className="ti ti-search"></i></span><input className="search-in" placeholder="Nom, n° pièce…" value={search} onChange={e => setSearch(e.target.value)} /></div>
            <select className="fsel" value={propFilter} onChange={e => setPropFilter(e.target.value)}>
              <option value="">Toutes propriétés</option>
              {properties.map(p => <option key={p.slug} value={p.slug}>{p.name}</option>)}
            </select>
            <select className="fsel" value={cinFilter} onChange={e => setCinFilter(e.target.value)}>
              <option value="">Tous</option><option value="1">CIN manquant</option>
            </select>
          </div>
        </div>
        {loading ? <div className="empty"><span className="spin" /></div> : fiches.length === 0 ? (
          <div className="empty"><div className="empty-ico"><i className="ti ti-file-text" style={{ fontSize: 26 }}></i></div><div className="empty-t">Aucune fiche</div></div>
        ) : (
          <div className="table-wrap"><table>
            <thead><tr><th>Guest</th><th>Propriété</th><th>Nationalité</th><th>Arrivée</th><th>Documents</th><th>Soumis</th><th></th></tr></thead>
            <tbody>
              {fiches.map(f => (
                <tr key={f.id}>
                  <td><div style={{ fontWeight: 600 }}>{f.prenom} {f.nom}</div><div style={{ fontSize: 10, color: 'var(--g3)', fontFamily: 'monospace' }}>{f.numero_piece}</div></td>
                  <td style={{ fontSize: 12, color: 'var(--g2)' }}>{f.property_name}</td>
                  <td>{f.nationalite}</td>
                  <td>{fmt(f.checkin_date)} {daysUntil(f.checkin_date) !== null && <span className={`badge ${daysUntil(f.checkin_date) <= 1 ? 'br' : daysUntil(f.checkin_date) <= 3 ? 'ba' : 'bgr'}`}>J-{Math.abs(daysUntil(f.checkin_date))}</span>}</td>
                  <td>
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                      {f.fiche_pdf_filename && <a className="doc-btn doc-btn-pdf" href={`${API}/admin/fiches/${f.id}/fiche-pdf?token=${tok()}`} target="_blank" rel="noreferrer"><i className="ti ti-file-text"></i>Fiche</a>}
                      {f.contract_pdf_filename && <a className="doc-btn doc-btn-pdf" href={`${API}/admin/fiches/${f.id}/contract-pdf?token=${tok()}`} target="_blank" rel="noreferrer"><i className="ti ti-clipboard-text"></i>Contrat</a>}
                      {f.cin_filename && <a className="doc-btn doc-btn-cin" href={`${API}/admin/fiches/${f.id}/cin?token=${tok()}`} target="_blank" rel="noreferrer"><i className="ti ti-id"></i>CIN</a>}
                    </div>
                  </td>
                  <td style={{ color: 'var(--g2)', fontSize: 11 }}>{fmt(f.submitted_at)}</td>
                  <td>
                    <button className="btn btn-s btn-sm" style={{ marginRight: 4 }} onClick={() => setSelected(f)}>Détail</button>
                    <button className="btn btn-d btn-sm btn-icon" onClick={() => del(f.id)}><i className="ti ti-trash"></i></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table></div>
        )}
        {pages > 1 && (
          <div className="pag">
            <div className="pag-info">{total} fiches · page {page}/{pages}</div>
            <div className="pag-btns">
              <button className="pag-btn" disabled={page <= 1} onClick={() => load(page - 1)}>←</button>
              {Array.from({ length: Math.min(pages, 5) }, (_, i) => i + 1).map(p => <button key={p} className={`pag-btn ${p === page ? 'on' : ''}`} onClick={() => load(p)}>{p}</button>)}
              <button className="pag-btn" disabled={page >= pages} onClick={() => load(page + 1)}>→</button>
            </div>
          </div>
        )}
      </div>
      {selected && <FicheModal fiche={selected} onClose={() => setSelected(null)} toast={toast} />}
    </div>
  );
}

// ── Contracts ─────────────────────────────────────────────────────────────────
function ContractModal({ contract, properties, onClose, onSave, toast }) {
  const isNew = !contract?.id;
  const parseArticles = (c) => {
    if (c?.articles_json) { try { const a = JSON.parse(c.articles_json); if (Array.isArray(a) && a.length) return a; } catch {} }
    if (c?.contract_text) return [{ title: 'Article 1', body: c.contract_text }];
    return [{ title: 'Article 1', body: '' }];
  };
  const [form, setForm] = useState(contract || { name: '', description: '', contract_text: '', rules_text: '', active: 1 });
  const [articles, setArticles] = useState(parseArticles(contract));
  const [selectedProps, setSelectedProps] = useState(contract?.property_ids || []);
  const [tab, setTab] = useState('info');
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const toggleProp = (id) => setSelectedProps(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]);

  const setArticle = (i, k, v) => setArticles(a => a.map((art, idx) => idx === i ? { ...art, [k]: v } : art));
  const addArticle = () => setArticles(a => [...a, { title: `Article ${a.length + 1}`, body: '' }]);
  const removeArticle = (i) => setArticles(a => a.length > 1 ? a.filter((_, idx) => idx !== i) : a);
  const moveArticle = (i, dir) => setArticles(a => {
    const j = i + dir;
    if (j < 0 || j >= a.length) return a;
    const copy = [...a];
    [copy[i], copy[j]] = [copy[j], copy[i]];
    return copy;
  });

  const articlesToText = (arts) => arts.map(a => `${a.title}\n\n${a.body}`).join('\n\n');

  const save = async () => {
    if (!form.name.trim()) { toast('Nom requis', 'err'); return; }
    const hasBody = articles.some(a => a.body.trim());
    if (!hasBody) { toast('Au moins un article doit avoir du contenu', 'err'); return; }
    setBusy(true);
    try {
      const body = {
        ...form,
        contract_text: articlesToText(articles),
        articles_json: JSON.stringify(articles),
        property_ids: selectedProps,
      };
      const r = await api(isNew ? '/admin/contracts' : `/admin/contracts/${contract.id}`, { method: isNew ? 'POST' : 'PUT', body: JSON.stringify(body) });
      const d = await r.json();
      if (d.success) { toast('Contrat sauvegardé', 'ok'); onSave(); onClose(); }
      else toast(d.error || 'Erreur', 'err');
    } catch { toast('Erreur réseau', 'err'); } finally { setBusy(false); }
  };

  const VARS = ['{{nom}}', '{{prenom}}', '{{nom_complet}}', '{{propriete}}', '{{adresse}}', '{{ville}}', '{{checkin}}', '{{checkout}}', '{{nationalite}}', '{{date_naissance}}', '{{numero_piece}}', '{{nature_piece}}', '{{date_jour}}'];

  return (
    <Modal title={isNew ? 'Nouveau contrat' : `Modifier — ${contract.name}`} onClose={onClose} wide
      footer={<><button className="btn btn-s" onClick={onClose}>Annuler</button><button className="btn btn-p" onClick={save} disabled={busy}>{busy ? <span className="spin" /> : 'Sauvegarder'}</button></>}>
      <div className="tabs">
        {['info', 'contract', 'rules', 'properties'].map(t => (
          <button key={t} className={`tab ${tab === t ? 'on' : ''}`} onClick={() => setTab(t)}>
            {t === 'info' ? 'Informations' : t === 'contract' ? 'Contrat' : t === 'rules' ? 'Règlement' : 'Propriétés'}
          </button>
        ))}
      </div>

      {tab === 'info' && (<>
        <div className="ff"><label className="fl">Nom du contrat *</label><input className="fi" value={form.name} onChange={e => set('name', e.target.value)} placeholder="Contrat Standard Marrakech" /></div>
        <div className="ff"><label className="fl">Description</label><input className="fi" value={form.description} onChange={e => set('description', e.target.value)} placeholder="Contrat pour les propriétés de Marrakech" /></div>
        <div className="ff"><label className="fl">Statut</label><select className="fsel2" value={form.active} onChange={e => set('active', parseInt(e.target.value))}><option value={1}>Actif</option><option value={0}>Inactif</option></select></div>
      </>)}

      {tab === 'contract' && (
        <div className="vars-hint">
          <strong>Variables disponibles :</strong>
          {VARS.map(v => <code key={v} style={{ marginRight: 6, background: '#F0F0EE', padding: '1px 5px', borderRadius: 4, fontSize: 11 }}>{v}</code>)}
        </div>
      )}

      {tab === 'contract' && (
        <div className="ff">
          <label className="fl">Articles du contrat *</label>
          {articles.map((art, i) => (
            <div key={i} style={{ border: '0.5px solid var(--border)', borderRadius: 12, padding: 12, marginBottom: 10 }}>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8 }}>
                <input className="fi" style={{ flex: 1, fontWeight: 600 }} value={art.title} onChange={e => setArticle(i, 'title', e.target.value)} placeholder={`Titre de l'article ${i + 1}`} />
                <button type="button" className="btn btn-s btn-sm btn-icon" onClick={() => moveArticle(i, -1)} disabled={i === 0}><i className="ti ti-arrow-up"></i></button>
                <button type="button" className="btn btn-s btn-sm btn-icon" onClick={() => moveArticle(i, 1)} disabled={i === articles.length - 1}><i className="ti ti-arrow-down"></i></button>
                <button type="button" className="btn btn-d btn-sm btn-icon" onClick={() => removeArticle(i)} disabled={articles.length === 1}><i className="ti ti-trash"></i></button>
              </div>
              <textarea className="fta" style={{ minHeight: 90 }} value={art.body} onChange={e => setArticle(i, 'body', e.target.value)} placeholder="Contenu de l'article. Utilisez les variables ci-dessus pour personnaliser automatiquement." />
            </div>
          ))}
          <button type="button" className="btn btn-s" style={{ width: '100%' }} onClick={addArticle}>+ Ajouter un article</button>
          <div style={{ fontSize: 11, color: 'var(--g2)', marginTop: 8 }}>Chaque article devient une section titrée dans le PDF. Les variables sont remplacées automatiquement par les données du guest.</div>
        </div>
      )}

      {tab === 'rules' && (
        <div className="ff">
          <label className="fl">Règlement intérieur</label>
          <textarea className="fta fta-contract" value={form.rules_text} onChange={e => set('rules_text', e.target.value)} placeholder="Rédigez le règlement intérieur ici." />
        </div>
      )}

      {tab === 'properties' && (<>
        <div style={{ fontSize: 13, color: 'var(--g2)', marginBottom: 12 }}>Sélectionnez les propriétés liées à ce contrat. Le contrat sera présenté aux guests de ces propriétés.</div>
        {properties.map(p => (
          <div key={p.id} className={`prop-check ${selectedProps.includes(p.id) ? 'on' : ''}`} onClick={() => toggleProp(p.id)}>
            <input type="checkbox" checked={selectedProps.includes(p.id)} onChange={() => {}} />
            <div><div style={{ fontSize: 13, fontWeight: 600 }}>{p.name}</div><div style={{ fontSize: 11, color: 'var(--g2)' }}>{p.city} · {p.slug}</div></div>
          </div>
        ))}
        {selectedProps.length === 0 && <div style={{ fontSize: 12, color: 'var(--amber)', marginTop: 8, display: 'flex', alignItems: 'center', gap: 6 }}><i className="ti ti-alert-triangle"></i>Aucune propriété liée — le contrat ne sera pas affiché aux guests</div>}
      </>)}
    </Modal>
  );
}

function Contracts({ properties, toast }) {
  const [contracts, setContracts] = useState([]);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api('/admin/contracts').then(r => r.json()).then(d => { if (d.success) setContracts(d.contracts); }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const del = async (c) => {
    if (!window.confirm(`Supprimer "${c.name}" ?`)) return;
    const r = await api(`/admin/contracts/${c.id}`, { method: 'DELETE' });
    const d = await r.json();
    toast(d.success ? 'Contrat supprimé' : d.error, d.success ? 'ok' : 'err');
    load();
  };

  const getPropNames = (contract) => {
    const ids = contract.property_ids || [];
    return ids.map(id => properties.find(p => p.id === id)?.name || id).join(', ') || '—';
  };

  return (
    <div className="content fia">
      <div style={{ background: '#f0f4ff', border: '1px solid #c7d7fd', borderRadius: 'var(--r12)', padding: '12px 16px', marginBottom: 14, fontSize: 13, color: '#3730a3' }}>
        <strong>Variables disponibles dans les contrats :</strong> <code>{'{{nom}}'}</code> <code>{'{{prenom}}'}</code> <code>{'{{nom_complet}}'}</code> <code>{'{{propriete}}'}</code> <code>{'{{adresse}}'}</code> <code>{'{{checkin}}'}</code> <code>{'{{checkout}}'}</code> <code>{'{{nationalite}}'}</code> <code>{'{{numero_piece}}'}</code> <code>{'{{date_jour}}'}</code>
      </div>
      <div className="card">
        <div className="card-hdr">
          <div className="card-title">Contrats <span style={{ color: 'var(--g2)', fontWeight: 400 }}>({contracts.length})</span></div>
          <button className="btn btn-p btn-sm" onClick={() => setModal({})}>+ Nouveau contrat</button>
        </div>
        {loading ? <div className="empty"><span className="spin" /></div> : contracts.length === 0 ? (
          <div className="empty"><div className="empty-ico"><i className="ti ti-file-off" style={{ fontSize: 26 }}></i></div><div className="empty-t">Aucun contrat</div><div className="empty-s">Créez un contrat et liez-le à vos propriétés</div></div>
        ) : (
          <table>
            <thead><tr><th>Nom</th><th>Description</th><th>Propriétés liées</th><th>Statut</th><th>Modifié</th><th></th></tr></thead>
            <tbody>
              {contracts.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight: 600 }}>{c.name}</td>
                  <td style={{ color: 'var(--g2)', fontSize: 12 }}>{c.description || '—'}</td>
                  <td style={{ fontSize: 12 }}>{getPropNames(c)}</td>
                  <td><span className={`badge ${c.active ? 'bg' : 'bgr'}`}>{c.active ? 'Actif' : 'Inactif'}</span></td>
                  <td style={{ color: 'var(--g2)', fontSize: 11 }}>{fmt(c.updated_at)}</td>
                  <td>
                    <button className="btn btn-s btn-sm" style={{ marginRight: 4 }} onClick={() => setModal(c)}>Modifier</button>
                    <button className="btn btn-d btn-sm" onClick={() => del(c)}>Suppr.</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {modal !== null && <ContractModal contract={Object.keys(modal).length ? modal : null} properties={properties} onClose={() => setModal(null)} onSave={load} toast={toast} />}
    </div>
  );
}

// ── Properties ────────────────────────────────────────────────────────────────
function Properties({ contracts, toast }) {
  const [props, setProps] = useState([]);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api('/admin/properties').then(r => r.json()).then(d => { if (d.success) setProps(d.properties); }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const del = async (p) => {
    if (!window.confirm(`Supprimer "${p.name}" ?`)) return;
    const r = await api(`/admin/properties/${p.id}`, { method: 'DELETE' });
    const d = await r.json();
    toast(d.message || (d.success ? 'Supprimé' : d.error), d.success ? 'ok' : 'err');
    load();
  };

  return (
    <div className="content fia">
      <div className="card">
        <div className="card-hdr">
          <div className="card-title">Propriétés <span style={{ color: 'var(--g2)', fontWeight: 400 }}>({props.length})</span></div>
          <button className="btn btn-p btn-sm" onClick={() => setModal({})}>+ Ajouter</button>
        </div>
        {loading ? <div className="empty"><span className="spin" /></div> : props.length === 0 ? <div className="empty"><div className="empty-ico"><i className="ti ti-home-off" style={{ fontSize: 26 }}></i></div><div className="empty-t">Aucune propriété</div></div> : (
          <table>
            <thead><tr><th>Propriété</th><th>Ville</th><th>Slug</th><th>Contrats liés</th><th>Fiches</th><th>Statut</th><th></th></tr></thead>
            <tbody>{props.map(p => (
              <tr key={p.id}>
                <td style={{ fontWeight: 600 }}>{p.name}</td>
                <td style={{ color: 'var(--g2)' }}>{p.city}</td>
                <td><code style={{ fontSize: 11, background: 'var(--bg)', padding: '2px 5px', borderRadius: 4 }}>{p.slug}</code></td>
                <td style={{ fontSize: 12 }}>{(p.contract_ids || []).length > 0 ? `${(p.contract_ids || []).length} contrat(s)` : <span style={{ color: 'var(--amber)' }}>Aucun</span>}</td>
                <td><span style={{ fontWeight: 700, color: 'var(--red)' }}>{p.fiches_count || 0}</span></td>
                <td><span className={`badge ${p.active ? 'bg' : 'bgr'}`}>{p.active ? 'Active' : 'Inactive'}</span></td>
                <td>
                  <button className="btn btn-s btn-sm" style={{ marginRight: 4 }} onClick={() => setModal(p)}>Modifier</button>
                  <button className="btn btn-d btn-sm" onClick={() => del(p)}>Suppr.</button>
                </td>
              </tr>
            ))}</tbody>
          </table>
        )}
      </div>
      {modal !== null && <PropModal prop={Object.keys(modal).length ? modal : null} contracts={contracts} onClose={() => setModal(null)} onSave={load} toast={toast} />}
    </div>
  );
}

function PropModal({ prop, contracts, onClose, onSave, toast }) {
  const isNew = !prop?.id;
  const [form, setForm] = useState(prop || { name: '', slug: '', address: '', city: 'Marrakech', max_guests: 4, active: 1 });
  const [selectedContracts, setSelectedContracts] = useState(prop?.contract_ids || []);
  const [tab, setTab] = useState('info');
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const toggleContract = (id) => setSelectedContracts(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]);
  const autoSlug = (name) => { set('name', name); if (isNew) set('slug', name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')); };

  const save = async () => {
    if (!form.name.trim() || !form.slug.trim()) { toast('Nom et slug requis', 'err'); return; }
    setBusy(true);
    try {
      const body = { ...form, contract_ids: selectedContracts };
      const r = await api(isNew ? '/admin/properties' : `/admin/properties/${prop.id}`, { method: isNew ? 'POST' : 'PUT', body: JSON.stringify(body) });
      const d = await r.json();
      if (d.success) { toast('Propriété sauvegardée', 'ok'); onSave(); onClose(); }
      else toast(d.error || 'Erreur', 'err');
    } catch { toast('Erreur réseau', 'err'); } finally { setBusy(false); }
  };

  return (
    <Modal title={isNew ? 'Nouvelle propriété' : `Modifier — ${prop.name}`} onClose={onClose}
      footer={<><button className="btn btn-s" onClick={onClose}>Annuler</button><button className="btn btn-p" onClick={save} disabled={busy}>{busy ? <span className="spin" /> : 'Sauvegarder'}</button></>}>
      <div className="tabs">
        {['info', 'contracts'].map(t => <button key={t} className={`tab ${tab === t ? 'on' : ''}`} onClick={() => setTab(t)}>{t === 'info' ? 'Informations' : 'Contrats liés'}</button>)}
      </div>
      {tab === 'info' && (<>
        <div className="frow">
          <div className="ff"><label className="fl">Nom *</label><input className="fi" value={form.name} onChange={e => autoSlug(e.target.value)} placeholder="Le Cubique de Guéliz" /></div>
          <div className="ff"><label className="fl">Slug *</label><input className="fi" value={form.slug} onChange={e => set('slug', e.target.value)} placeholder="cubique" /><div style={{ fontSize: 10, color: 'var(--g2)', marginTop: 3 }}>guest.hospeo.com/?prop=<strong>{form.slug || '...'}</strong></div></div>
        </div>
        <div className="frow">
          <div className="ff"><label className="fl">Ville</label><input className="fi" value={form.city} onChange={e => set('city', e.target.value)} /></div>
          <div className="ff"><label className="fl">Capacité max</label><input className="fi" type="number" value={form.max_guests} onChange={e => set('max_guests', e.target.value)} min={1} /></div>
        </div>
        <div className="ff"><label className="fl">Adresse</label><input className="fi" value={form.address} onChange={e => set('address', e.target.value)} placeholder="17 Rue des Courlis, Appt 8" /></div>
        {!isNew && <div className="ff"><label className="fl">Statut</label><select className="fsel2" value={form.active} onChange={e => set('active', parseInt(e.target.value))}><option value={1}>Active</option><option value={0}>Inactive</option></select></div>}
      </>)}
      {tab === 'contracts' && (<>
        <div style={{ fontSize: 13, color: 'var(--g2)', marginBottom: 12 }}>Sélectionnez les contrats à présenter aux guests de cette propriété.</div>
        {contracts.length === 0 ? <div style={{ fontSize: 13, color: 'var(--amber)', display: 'flex', alignItems: 'center', gap: 6 }}><i className="ti ti-alert-triangle"></i>Aucun contrat disponible — créez d'abord un contrat dans l'onglet Contrats</div> :
          contracts.map(c => (
            <div key={c.id} className={`prop-check ${selectedContracts.includes(c.id) ? 'on' : ''}`} onClick={() => toggleContract(c.id)}>
              <input type="checkbox" checked={selectedContracts.includes(c.id)} onChange={() => {}} />
              <div><div style={{ fontSize: 13, fontWeight: 600 }}>{c.name}</div><div style={{ fontSize: 11, color: 'var(--g2)' }}>{c.description}</div></div>
            </div>
          ))
        }
      </>)}
    </Modal>
  );
}

// ── Users ─────────────────────────────────────────────────────────────────────
function Users({ toast, currentAdmin }) {
  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(() => { setLoading(true); api('/admin/users').then(r => r.json()).then(d => { if (d.success) setUsers(d.users); }).catch(() => {}).finally(() => setLoading(false)); }, []);
  useEffect(() => { load(); }, [load]);
  const del = async (u) => {
    if (!window.confirm(`Supprimer "${u.name || u.email}" ?`)) return;
    const r = await api(`/admin/users/${u.id}`, { method: 'DELETE' });
    const d = await r.json();
    toast(d.success ? 'Utilisateur supprimé' : d.error, d.success ? 'ok' : 'err');
    load();
  };
  const roleStyle = { superadmin: 'br', admin: 'bb', staff: 'bg' };
  return (
    <div className="content fia">
      <div className="card">
        <div className="card-hdr"><div className="card-title">Utilisateurs ({users.length})</div><button className="btn btn-p btn-sm" onClick={() => setModal({})}>+ Ajouter</button></div>
        {loading ? <div className="empty"><span className="spin" /></div> : (
          <table>
            <thead><tr><th>Nom</th><th>Email</th><th>Rôle</th><th>Statut</th><th>Créé</th><th></th></tr></thead>
            <tbody>{users.map(u => (
              <tr key={u.id}>
                <td style={{ fontWeight: 600 }}>{u.name || '—'} {u.id === currentAdmin?.id && <span className="badge bb" style={{ fontSize: 9 }}>vous</span>}</td>
                <td style={{ color: 'var(--g2)' }}>{u.email}</td>
                <td><span className={`badge ${roleStyle[u.role] || 'bgr'}`}>{u.role}</span></td>
                <td><span className={`badge ${u.active ? 'bg' : 'bgr'}`}>{u.active ? 'Actif' : 'Inactif'}</span></td>
                <td style={{ color: 'var(--g2)', fontSize: 11 }}>{fmt(u.created_at)}</td>
                <td>
                  <button className="btn btn-s btn-sm" style={{ marginRight: 4 }} onClick={() => setModal(u)}>Modifier</button>
                  {u.id !== currentAdmin?.id && <button className="btn btn-d btn-sm" onClick={() => del(u)}>Suppr.</button>}
                </td>
              </tr>
            ))}</tbody>
          </table>
        )}
      </div>
      {modal !== null && <UserModal user={Object.keys(modal).length ? modal : null} onClose={() => setModal(null)} onSave={load} toast={toast} currentAdmin={currentAdmin} />}
    </div>
  );
}

function UserModal({ user, onClose, onSave, toast, currentAdmin }) {
  const isNew = !user?.id;
  const [form, setForm] = useState(user || { name: '', email: '', password: '', role: 'staff', active: 1 });
  const [pw, setPw] = useState({ current: '', newpw: '', confirm: '' });
  const [tab, setTab] = useState('info');
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async () => {
    setBusy(true);
    try {
      const body = isNew ? form : { name: form.name, email: form.email, role: form.role, active: form.active };
      const r = await api(isNew ? '/admin/users' : `/admin/users/${user.id}`, { method: isNew ? 'POST' : 'PUT', body: JSON.stringify(body) });
      const d = await r.json();
      if (d.success) { toast('Utilisateur sauvegardé', 'ok'); onSave(); onClose(); }
      else toast(d.error || 'Erreur', 'err');
    } catch { toast('Erreur réseau', 'err'); } finally { setBusy(false); }
  };

  const savePw = async () => {
    if (pw.newpw !== pw.confirm) { toast('Les mots de passe ne correspondent pas', 'err'); return; }
    if (pw.newpw.length < 6) { toast('Mot de passe trop court', 'err'); return; }
    setBusy(true);
    try {
      const body = { new_password: pw.newpw };
      if (user?.id === currentAdmin?.id) body.current_password = pw.current;
      const r = await api(`/admin/users/${user.id}/password`, { method: 'PUT', body: JSON.stringify(body) });
      const d = await r.json();
      if (d.success) { toast('Mot de passe mis à jour', 'ok'); onClose(); }
      else toast(d.error || 'Erreur', 'err');
    } catch { toast('Erreur réseau', 'err'); } finally { setBusy(false); }
  };

  return (
    <Modal title={isNew ? 'Nouvel utilisateur' : `Modifier — ${user.name || user.email}`} onClose={onClose}
      footer={<><button className="btn btn-s" onClick={onClose}>Annuler</button><button className="btn btn-p" onClick={tab === 'pw' ? savePw : save} disabled={busy}>{busy ? <span className="spin" /> : 'Sauvegarder'}</button></>}>
      {!isNew && <div className="tabs">{['info', 'pw'].map(t => <button key={t} className={`tab ${tab === t ? 'on' : ''}`} onClick={() => setTab(t)}>{t === 'info' ? 'Informations' : 'Mot de passe'}</button>)}</div>}
      {tab === 'info' && (<>
        <div className="ff"><label className="fl">Nom</label><input className="fi" value={form.name} onChange={e => set('name', e.target.value)} placeholder="Prénom Nom" /></div>
        <div className="ff"><label className="fl">Email *</label><input className="fi" type="email" value={form.email} onChange={e => set('email', e.target.value)} /></div>
        {isNew && <div className="ff"><label className="fl">Mot de passe *</label><input className="fi" type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder="Min. 6 caractères" /></div>}
        <div className="frow">
          <div className="ff"><label className="fl">Rôle</label><select className="fsel2" value={form.role} onChange={e => set('role', e.target.value)}><option value="staff">Staff</option><option value="admin">Admin</option><option value="superadmin">Super Admin</option></select></div>
          {!isNew && <div className="ff"><label className="fl">Statut</label><select className="fsel2" value={form.active} onChange={e => set('active', parseInt(e.target.value))}><option value={1}>Actif</option><option value={0}>Inactif</option></select></div>}
        </div>
      </>)}
      {tab === 'pw' && (<>
        {user?.id === currentAdmin?.id && <div className="ff"><label className="fl">Mot de passe actuel</label><input className="fi" type="password" value={pw.current} onChange={e => setPw(f => ({ ...f, current: e.target.value }))} /></div>}
        <div className="ff"><label className="fl">Nouveau mot de passe</label><input className="fi" type="password" value={pw.newpw} onChange={e => setPw(f => ({ ...f, newpw: e.target.value }))} /></div>
        <div className="ff"><label className="fl">Confirmer</label><input className="fi" type="password" value={pw.confirm} onChange={e => setPw(f => ({ ...f, confirm: e.target.value }))} /></div>
      </>)}
    </Modal>
  );
}

// ── Settings ──────────────────────────────────────────────────────────────────
function Settings({ toast, admin }) {
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [stampFile, setStampFile] = useState(null);
  const [stampPreview, setStampPreview] = useState(null);
  const [pw, setPw] = useState({ current: '', newpw: '', confirm: '' });
  const [busy, setBusy] = useState(false);
  const logoRef = useRef(null);
  const stampRef = useRef(null);
  useEffect(() => { fetch(`${API}/settings/logo`).then(r => r.json()).then(d => { if (d?.url) setLogoPreview(d.url); }).catch(() => {}); }, []);
  useEffect(() => { fetch(`${API}/settings/stamp`).then(r => r.json()).then(d => { if (d?.url) setStampPreview(d.url); }).catch(() => {}); }, []);
  const handleLogo = (f) => { if (!f) return; setLogoFile(f); const reader = new FileReader(); reader.onload = e => setLogoPreview(e.target.result); reader.readAsDataURL(f); };
  const handleStamp = (f) => {
    if (!f) return;
    if (f.type !== 'image/png') { toast('Le cachet doit être un fichier PNG', 'err'); return; }
    setStampFile(f); const reader = new FileReader(); reader.onload = e => setStampPreview(e.target.result); reader.readAsDataURL(f);
  };
  const saveLogo = async () => {
    if (!logoFile) return; setBusy(true);
    try { const fd = new FormData(); fd.append('logo', logoFile); const r = await fetch(`${API}/admin/logo`, { method: 'POST', headers: { Authorization: `Bearer ${tok()}` }, body: fd }); const d = await r.json(); if (d.success) { toast('Logo mis à jour', 'ok'); setLogoFile(null); } else toast(d.error, 'err'); } catch { toast('Erreur', 'err'); } finally { setBusy(false); }
  };
  const saveStamp = async () => {
    if (!stampFile) return; setBusy(true);
    try { const fd = new FormData(); fd.append('stamp', stampFile); const r = await fetch(`${API}/admin/stamp`, { method: 'POST', headers: { Authorization: `Bearer ${tok()}` }, body: fd }); const d = await r.json(); if (d.success) { toast('Cachet mis à jour', 'ok'); setStampFile(null); setStampPreview(d.url); } else toast(d.error, 'err'); } catch { toast('Erreur', 'err'); } finally { setBusy(false); }
  };
  const removeStamp = async () => {
    if (!window.confirm('Retirer le cachet ? Il n\'apparaîtra plus sur les contrats.')) return;
    setBusy(true);
    try { const r = await fetch(`${API}/admin/stamp`, { method: 'DELETE', headers: { Authorization: `Bearer ${tok()}` } }); const d = await r.json(); if (d.success) { toast('Cachet retiré', 'ok'); setStampPreview(null); } else toast(d.error, 'err'); } catch { toast('Erreur', 'err'); } finally { setBusy(false); }
  };
  const savePw = async () => {
    if (pw.newpw !== pw.confirm) { toast('Mots de passe différents', 'err'); return; }
    if (pw.newpw.length < 6) { toast('Trop court', 'err'); return; }
    setBusy(true);
    try { const r = await api(`/admin/users/${admin.id}/password`, { method: 'PUT', body: JSON.stringify({ current_password: pw.current, new_password: pw.newpw }) }); const d = await r.json(); if (d.success) { toast('Mot de passe mis à jour', 'ok'); setPw({ current: '', newpw: '', confirm: '' }); } else toast(d.error, 'err'); } catch { toast('Erreur', 'err'); } finally { setBusy(false); }
  };
  return (
    <div className="content fia">
      <div className="grid-3">
        <div className="card">
          <div className="card-hdr"><div className="card-title">Logo</div></div>
          <div style={{ padding: 16 }}>
            <div style={{ border: `2px dashed ${logoPreview ? 'var(--green)' : 'var(--border)'}`, borderRadius: 'var(--r12)', padding: 24, textAlign: 'center', cursor: 'pointer' }} onClick={() => logoRef.current.click()}>
              <input ref={logoRef} type="file" accept=".png,.jpg,.jpeg,.svg,.webp" style={{ display: 'none' }} onChange={e => handleLogo(e.target.files[0])} />
              {logoPreview ? <img src={logoPreview} alt="Logo" style={{ height: 44, objectFit: 'contain', display: 'block', margin: '0 auto 8px' }} /> : <div className="upload-ico"><i className="ti ti-photo"></i></div>}
              <div style={{ fontSize: 13, fontWeight: 600, color: logoPreview ? 'var(--green)' : 'var(--black)' }}>{logoPreview ? 'Changer le logo' : 'Uploader le logo'}</div>
              <div style={{ fontSize: 11, color: 'var(--g2)', marginTop: 2 }}>PNG, SVG, JPG · max 2MB</div>
            </div>
            {logoFile && <button className="btn btn-p" style={{ width: '100%', marginTop: 10 }} onClick={saveLogo} disabled={busy}>{busy ? <span className="spin" /> : 'Enregistrer'}</button>}
          </div>
        </div>
        <div className="card">
          <div className="card-hdr"><div className="card-title">Cachet Hospeo SARL</div></div>
          <div style={{ padding: 16 }}>
            <div style={{ border: `2px dashed ${stampPreview ? 'var(--green)' : 'var(--border)'}`, borderRadius: 'var(--r12)', padding: 24, textAlign: 'center', cursor: 'pointer' }} onClick={() => stampRef.current.click()}>
              <input ref={stampRef} type="file" accept=".png" style={{ display: 'none' }} onChange={e => handleStamp(e.target.files[0])} />
              {stampPreview ? <img src={stampPreview} alt="Cachet" style={{ height: 60, objectFit: 'contain', display: 'block', margin: '0 auto 8px' }} /> : <div className="upload-ico"><i className="ti ti-stamp"></i></div>}
              <div style={{ fontSize: 13, fontWeight: 600, color: stampPreview ? 'var(--green)' : 'var(--black)' }}>{stampPreview ? 'Changer le cachet' : 'Uploader le cachet'}</div>
              <div style={{ fontSize: 11, color: 'var(--g2)', marginTop: 2 }}>PNG uniquement, fond transparent recommandé · max 2MB</div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
              {stampFile && <button className="btn btn-p" style={{ flex: 1 }} onClick={saveStamp} disabled={busy}>{busy ? <span className="spin" /> : 'Enregistrer'}</button>}
              {stampPreview && !stampFile && <button className="btn btn-d" style={{ flex: 1 }} onClick={removeStamp} disabled={busy}>Retirer le cachet</button>}
            </div>
            <div style={{ fontSize: 11, color: 'var(--g2)', marginTop: 8 }}>Ce cachet apparaît sur le bloc de signature des contrats guest.</div>
          </div>
        </div>
        <div className="card">
          <div className="card-hdr"><div className="card-title">Changer mon mot de passe</div></div>
          <div style={{ padding: 16 }}>
            <div className="ff"><label className="fl">Mot de passe actuel</label><input className="fi" type="password" value={pw.current} onChange={e => setPw(f => ({ ...f, current: e.target.value }))} /></div>
            <div className="ff"><label className="fl">Nouveau mot de passe</label><input className="fi" type="password" value={pw.newpw} onChange={e => setPw(f => ({ ...f, newpw: e.target.value }))} /></div>
            <div className="ff"><label className="fl">Confirmer</label><input className="fi" type="password" value={pw.confirm} onChange={e => setPw(f => ({ ...f, confirm: e.target.value }))} /></div>
            <button className="btn btn-p" style={{ width: '100%' }} onClick={savePw} disabled={busy}>{busy ? <span className="spin" /> : 'Mettre à jour'}</button>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-hdr"><div className="card-title">Liens guest par propriété</div></div>
        <div style={{ padding: 16 }}>
          <div style={{ fontSize: 13, color: 'var(--g2)', marginBottom: 8 }}>Format du lien : <code style={{ background: 'var(--bg)', padding: '2px 6px', borderRadius: 4 }}>https://guest.hospeo.com/?prop=SLUG</code></div>
          {['cubique', 'casablanca-centrale', 'loft-hivernage', 'cocoon-hivernage', 'olivia-lodge', 'cosy-gueliz', 'coralline'].map(s => (
            <div key={s} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '7px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
              <code style={{ color: 'var(--blue)' }}>{s}</code>
              <a href={`https://guest.hospeo.com/?prop=${s}`} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: 'var(--black)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4 }}>Ouvrir<i className="ti ti-external-link"></i></a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── Alerts ────────────────────────────────────────────────────────────────────
function Alerts() {
  const [data, setData] = useState(null);
  useEffect(() => { api('/admin/checkin-tomorrow').then(r => r.json()).then(d => { if (d.success) setData(d); }).catch(() => {}); }, []);
  if (!data) return <div className="content"><div className="empty"><span className="spin" /></div></div>;
  return (
    <div className="content fia">
      <div className="card">
        <div className="card-hdr"><div className="card-title">Check-in demain — {data.date}</div></div>
        {data.fiches.length === 0 ? <div className="empty"><div className="empty-ico"><i className="ti ti-circle-check" style={{ fontSize: 26 }}></i></div><div className="empty-t">Aucune arrivée demain</div></div> : (
          <table><thead><tr><th>Guest</th><th>Propriété</th><th>Arrivée</th><th>CIN</th></tr></thead>
            <tbody>{data.fiches.map((f, i) => <tr key={i}><td style={{ fontWeight: 600 }}>{f.prenom} {f.nom}</td><td>{f.property_name}</td><td>{fmt(f.checkin_date)}</td><td>{f.cin_filename ? <span className="badge bg"><i className="ti ti-check"></i></span> : <span className="badge br"><i className="ti ti-x"></i>Manquant</span>}</td></tr>)}</tbody>
          </table>
        )}
      </div>
      {data.missing.length > 0 && (
        <div className="card" style={{ borderColor: '#ffcdd2' }}>
          <div className="card-hdr" style={{ background: '#fff5f5' }}><div className="card-title" style={{ color: '#791F1F' }}><i className="ti ti-alert-triangle"></i>CIN manquants à relancer</div></div>
          <table><thead><tr><th>Guest</th><th>Propriété</th><th>Arrivée</th></tr></thead>
            <tbody>{data.missing.map((f, i) => <tr key={i}><td style={{ fontWeight: 600 }}>{f.prenom} {f.nom}</td><td>{f.property_name}</td><td><span className="badge br">{fmt(f.checkin_date)}</span></td></tr>)}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ── Redesign screens ──────────────────────────────────────────────────────────
function PropertyPageScreen({ properties, toast, m }) {
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (!selectedId && properties.length > 0) {
      setSelectedId(properties[0].id);
    }
  }, [properties, selectedId]);

  const selectedProperty = properties.find(
    p => String(p.id) === String(selectedId)
  );

  return (
    <div className="content fia">
      <div className="card" style={{ marginBottom: 14, padding: 12 }}>
        <select
          className="fsel2"
          value={selectedId || ''}
          onChange={(e) => setSelectedId(e.target.value)}
        >
          {properties.map(p => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>
      </div>

      {selectedId ? (
        <PropertyPage
          property={selectedProperty}
          m={m}
          toast={toast}
        />
      ) : (
        <div className="card" style={{ padding: 20 }}>
          Aucune propriété disponible.
        </div>
      )}
    </div>
  );
}

function AmenitiesScreen({ properties, toast, m }) {
  const [selectedId, setSelectedId] = useState(null);

  // Properties are loaded asynchronously, so don't assume properties[0]
  // exists on the first render.
  useEffect(() => {
    if (!selectedId && properties.length > 0) {
      setSelectedId(properties[0].id);
    }
  }, [properties, selectedId]);

  const selectedProperty = properties.find(
    p => String(p.id) === String(selectedId)
  );

  return (
    <div className="content fia">
      <div className="card" style={{ marginBottom: 14, padding: 12 }}>
        <select
          className="fsel2"
          value={selectedId || ''}
          onChange={(e) => setSelectedId(e.target.value)}
        >
          {properties.map(p => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>
      </div>

      {selectedId ? (
        <Amenities
          propertyId={selectedId}
          propertyName={selectedProperty?.name || ''}
          m={m}
          toast={toast}
        />
      ) : (
        <div className="card" style={{ padding: 20 }}>
          Aucune propriété disponible.
        </div>
      )}
    </div>
  );
}

// ── App ───────────────────────────────────────────────────────────────────────
const PAGES = [
  { id: 'dashboard', label: 'Dashboard', ico: 'ti-layout-dashboard' },
  { id: 'fiches', label: 'Fiches', ico: 'ti-file-text' },
  { id: 'contracts', label: 'Contrats', ico: 'ti-clipboard-text' },
  { id: 'properties', label: 'Propriétés', ico: 'ti-home' },
  { id: 'property-page', label: 'Guide propriété', ico: 'ti-map-2' },
  { id: 'amenities', label: 'Équipements', ico: 'ti-tool' },
  { id: 'integrations', label: 'Intégrations', ico: 'ti-plug' },
  { id: 'users', label: 'Utilisateurs', ico: 'ti-users' },
  { id: 'alerts', label: 'Alertes', ico: 'ti-bell' },
  { id: 'settings', label: 'Paramètres', ico: 'ti-settings' },
];

export default function App() {
  const [admin, setAdmin] = useState(() => {
    try { const t = tok(); if (!t) return null; const p = JSON.parse(atob(t.split('.')[1])); return { id: p.id, email: p.email, name: p.name, role: p.role }; } catch { return null; }
  });
  const [page, setPage] = useState('dashboard');
  const [properties, setProperties] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [logoUrl, setLogoUrl] = useState(null);
  const [toast, setToast] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const showToast = useCallback((msg, type = 'ok') => setToast({ msg, type }), []);

  useEffect(() => {
    if (!admin) return;
    api('/admin/properties').then(r => r.json()).then(d => { if (d.success) setProperties(d.properties); }).catch(() => {});
    api('/admin/contracts').then(r => r.json()).then(d => { if (d.success) setContracts(d.contracts); }).catch(() => {});
    fetch(`${API}/settings/logo`).then(r => r.json()).then(d => { if (d?.url) setLogoUrl(d.url); }).catch(() => {});
  }, [admin, page]);

  const logout = () => { localStorage.removeItem('hospeo_token'); setAdmin(null); };

  if (!admin) return <><style>{CSS}</style><Login onLogin={setAdmin} /></>;

  return (
    <>
      <style>{CSS}</style>
      {toast && <Toast msg={toast.msg} type={toast.type} onDone={() => setToast(null)} />}
      <div className="layout">
        <div className={`sb-overlay ${sidebarOpen ? 'open' : ''}`} onClick={() => setSidebarOpen(false)} />
        <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
          <div className="sb-logo">
            {logoUrl ? <img src={logoUrl} alt="Logo" /> : <div><div className="sb-logo-t">HOSPEO</div><div className="sb-logo-s">Administration</div></div>}
            <button className="sb-close" onClick={() => setSidebarOpen(false)}><i className="ti ti-x"></i></button>
          </div>
          <nav className="sb-nav">
            <div className="sb-sec">Menu</div>
            {PAGES.map(p => <button key={p.id} className={`ni ${page === p.id ? 'on' : ''}`} onClick={() => { setPage(p.id); setSidebarOpen(false); }}><span className="ni-ico"><i className={`ti ${p.ico}`}></i></span>{p.label}</button>)}
            <div className="sb-sec" style={{ marginTop: 8 }}>Liens</div>
            <button className="ni" onClick={() => window.open('https://guest.hospeo.com/?prop=cubique', '_blank')}><span className="ni-ico"><i className="ti ti-link"></i></span>Formulaire guest</button>
          </nav>
          <div className="sb-foot">
            <div className="sb-user">{admin.name || 'Admin'}</div>
            <div className="sb-email">{admin.email}</div>
            <button className="sb-out" onClick={logout}><i className="ti ti-logout"></i>Se déconnecter</button>
          </div>
        </div>
        <div className="main">
          <div className="topbar">
            <div className="topbar-left">
              <button className="sb-burger" onClick={() => setSidebarOpen(true)}><i className="ti ti-menu-2"></i></button>
              <div className="page-title">{PAGES.find(p => p.id === page)?.label}</div>
            </div>
            <div className="topbar-date">{new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })}</div>
          </div>
          {page === 'dashboard' && <Dashboard onNav={setPage} />}
          {page === 'fiches' && <Fiches properties={properties} toast={showToast} />}
          {page === 'contracts' && <Contracts properties={properties} toast={showToast} />}
          {page === 'properties' && <Properties contracts={contracts} toast={showToast} />}
          {page === 'amenities' && <AmenitiesScreen properties={properties} toast={showToast} m={api} />}
          {page === 'property-page' && <PropertyPageScreen properties={properties} toast={showToast} m={api} />}
          {page === 'integrations' && <Integrations properties={properties} toast={showToast} m={api} />}
          {page === 'users' && <Users toast={showToast} currentAdmin={admin} />}
          {page === 'alerts' && <Alerts />}
          {page === 'settings' && <Settings toast={showToast} admin={admin} />}
        </div>
      </div>
    </>
  );
}
